<header class="container-fluid bg-white header header-shadow m-0 p-0">
  <nav class="navbar navbar-expand-lg bg-white" style="justify-content: space-between;">
    <a class="navbar-brand" routerLink="/">
      <img src="assets/images/dod_logo_positivedb_273x32px 1.png" alt="Tata Steel logo" />
    </a>
      @if (authService.isLoggedIn && !isOnDemoRoute()) {
        <div class="avatar-wrapper row">
       <div class="col-6">
        <mat-icon class="contactusicon"  routerLink="support">perm_phone_msg</mat-icon>
       </div>
       <div  class="col-6">
        <button class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" data-bs-display="static" aria-expanded="false">
          <p-avatar [label]="initials" styleClass="btn-primary text-white dropdown-toggle" shape="circle"></p-avatar>
        </button>
        <ul class="dropdown-menu">
          <li class="d-flex">
            <section  class="menu-avatar">
              <p-avatar [label]="initials" styleClass="mr-2 bg-primary text-white" shape="circle"></p-avatar>
            </section>
            <section>
              <div class="menu menu-fullname"><strong>{{fullName}}</strong></div>
              <div class="menu menu-username">{{username}}</div>
            </section>
          </li>
          <li><hr class="menu menu-divider"></li>
          <li><a class="menu menu-signout dropdown-item" routerLink="user-profile">
                <span class="material-symbols-outlined" style="position: relative; top:6px; font-size: 24px;">account_circle</span>
                &nbsp;Account
              </a>
          </li>
          @if(odinROleFlag){
 <li><a class="menu menu-signout dropdown-item" routerLink="where-is-my-steel">
            <span class="material-symbols-outlined" style="position: relative; top:6px; font-size: 24px;">shopping_cart</span>
            &nbsp;Where is my Steel ?
          </a>
      </li>
          }
         
          <li><a class="menu menu-signout dropdown-item" routerLink="settings">
                <span class="material-symbols-outlined" style="position: relative; top:6px; font-size: 24px;">settings</span>
                &nbsp;Settings
              </a>
          </li>
          <li><a class="menu menu-signout dropdown-item" routerLink="support">
            <span class="material-symbols-outlined" style="position: relative; top:6px; font-size: 24px;">info</span>
            &nbsp;Support
          </a>
          </li>
          <li><a class="menu menu-signout dropdown-item" href="#" (click)="logout()">
            <span class="material-icons-outlined" style="position: relative; top:6px; font-size: 24px;">logout</span>
            &nbsp;Sign out
          </a></li>
        </ul>
      </div>
       </div>
           

         
      } @else if (!authService.isLoggedIn && isOnDemoRoute()) {
        <button class="btn btn-outline-primary" (click)="login()" [class]="isOnLoginRoute() ? 'invisible' : 'visible'">
          Login
        </button>
      }
  </nav>
</header>
